export default __webpack_public_path__ + "static/media/1781.e20d589f.png";